<app-site-header />
<section class="content-area-layout1">
    <section class="content-area-layout2">
        <h3>Dealer Reps</h3>
        <p>Optional Search Criteria:</p>
        <form [formGroup]="viewDealerRepsForm">
            <div class="field-container">
                <mat-form-field>
                    <mat-label>Last Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="lastName"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>First Name</mat-label>
                    <input matInput #input maxlength="50" formControlName="firstName"/>
                </mat-form-field>
                <mat-form-field>
                    <mat-label>Email</mat-label>
                    <input matInput #input maxlength="255" formControlName="email"/>
                </mat-form-field>
                @if (userTypeEquals("employee")) {
                <app-dealer-names-component/>
                }
                <mat-form-field>
                    <mat-label>Rep ID</mat-label>
                    <input matInput #input maxlength="10" formControlName="dealerRepId">
                </mat-form-field>
            </div>
        </form>
        <section style="padding-top: 1vw; padding-bottom: 1vw;">
            <button style="margin-right: 1vw;" mat-flat-button (click)="listDealerReps()">Search</button>
            <button style="margin-right: 1vw;" mat-flat-button (click)="resetSearch()">Reset Search</button>
            @if (userHasRole("dealer-rep-editor")) {
            <button mat-flat-button (click)="addDealerRep()">Add Rep</button>
            }
        </section>

        <p class="text-aerostar-orange">{{message}}</p>

        @if (dealerRepCount > 0) {
        <p>Click on row to expand for additional information.</p>
        <div>
            <mat-accordion>
                <section class="mat-elevation-z2 mat-header-row">
                    <span class="mat-header-cell">DealerRep ID</span>
                    <span class="mat-header-cell">First Name</span>
                    <span class="mat-header-cell">Last Name</span>
                    <span class="mat-header-cell">Email</span>
                    <span class="mat-header-cell">Phone</span>
                    @if (userTypeEquals("employee")) {
                    <span class="mat-header-cell">Dealer</span>
                    }
                    <!-- dealer-rep-admin does not inherit dealer-rep-editor.
                         See comments in backend rbac.py module for additional
                         info
                    -->
                    @if (userHasRole("dealer-rep-editor") || (userHasRole("dealer-rep-admin"))) {
                    <span class="mat-header-cell">Actions</span>
                    }
                </section>
                <mat-expansion-panel hideToggle *ngFor="let dealerRep of dealerReps">
                    <mat-expansion-panel-header class="mat-row">
                        <span class="mat-cell">{{dealerRep.id}}</span>
                        <span class="mat-cell">{{dealerRep.first_name}}</span>
                        <span class="mat-cell">{{dealerRep.last_name}}</span>
                        <span class="mat-cell">{{dealerRep.email}}</span>
                        <span class="mat-cell">{{dealerRep.phone}}</span>
                        @if (userTypeEquals("employee")) {
                        <span class="mat-cell">{{dealerRep.dealer?.name}}</span>
                        }
                        @if (userHasRole("dealer-rep-editor") || (userHasRole("dealer-rep-admin"))) {
                        <span class="mat-cell">
                            <ng-container matColumnDef="more-vert">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="View and Update Actions"
                                    (click)=$event.stopPropagation()>
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    @if (userHasRole("dealer-rep-editor")) {
                                    @if (dealerRep.status == "A") {
                                    <button mat-menu-item (click)="updateDealerRep(dealerRep.id)">
                                        <span>Update Dealer Rep</span>
                                    </button>
                                    }
                                    <button mat-menu-item (click)="deleteDealerRepLogical(dealerRep.id)">
                                        <span>Delete Dealer Rep</span>
                                    </button>
                                    }
                                    @if (userHasRole("dealer-rep-admin")) {
                                    @if (dealerRep.status == "A") {
                                    <button mat-menu-item (click)="inactivateDealerRep(dealerRep.id)">
                                        <span>Inactivate Dealer Rep</span>
                                    </button>
                                    } @else {
                                    <button mat-menu-item (click)="reactivateDealerRep(dealerRep.id)">
                                        <span>Reactivate Dealer</span>
                                    </button>
                                    }
                                    }
                                    @if (userHasRole("dealer-rep-editor") && isNonProd) {
                                    <button mat-menu-item>
                                        <span (click)="deleteDealerRep(dealerRep.id)">Delete Dealer
                                            Rep<br><sup>(Physical Delete<br>Limited to Non-Prod Env)</sup></span>
                                    </button>
                                    }
                                </mat-menu>
                            </ng-container>
                        </span>
                        }
                    </mat-expansion-panel-header>
                    <div>
                        <pre>Nothing here, remove expansion panel.</pre>
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>

        <mat-paginator #paginator (page)="handlePageEvent($event)" [length]="dealerRepCount" [pageSize]="pageSize"
            [disabled]="false" [showFirstLastButtons]="true" [pageSizeOptions]="[5, 10, 25]" [hidePageSize]="false"
            [pageIndex]="pageIndex" aria-label="Select page">
        </mat-paginator>
        }
        @if (dealerRepCount == 0) {
        <p>No Dealer Reps found</p>
        }
    </section>
</section>